import { Component, OnInit } from '@angular/core';
import { NgIf, DatePipe } from '@angular/common';

@Component({
    selector: 'app-campaign-websocket-window',
    templateUrl: './campaign-websocket-window.component.html',
    styleUrls: ['./campaign-websocket-window.component.scss'],
    imports: [NgIf, DatePipe]
})
export class CampaignWebsocketWindowComponent implements OnInit {
  public results;

  constructor() { }

  public ngOnInit() {
  }
}
